// import React from 'react';

// // Arrow Right Icon
// const ArrowRight = () => (
//   <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path 
//       d="M5 12H19M19 12L12 5M19 12L12 19" 
//       stroke="currentColor" 
//       strokeWidth="2" 
//       strokeLinecap="round" 
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// export const GetStartedButton = ({
//   children = 'GET STARTED',
//   onClick,
//   type = 'button',
//   className = '',
//   disabled = false
// }) => {
//   return (
//     <button
//       type={type}
//       onClick={onClick}
//       disabled={disabled}
//       className={`
//         bg-gradient-to-r from-cyan-400 via-cyan-500 to-blue-500
//         hover:from-cyan-300 hover:via-cyan-400 hover:to-blue-400
//         text-slate-900
//         rounded-[1rem]
//         border-4 border-slate-900
        
//         transition-all duration-300
        
//         disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100
//         flex items-center overflow-hidden
//         ${className}
//       `}
//     >
//       {/* Text Side */}
//       <div className="flex-1 px-10 sm:px-16 py-4 sm:py-5 font-bold text-xl sm:text-2xl uppercase tracking-wider">
//         {children}
//       </div>
      
//       {/* Arrow Side with Border */}
//       <div className="h-full px-8 sm:px-10 py-4 sm:py-5 bg-gradient-to-r from-blue-500 to-blue-600 border-l-4 border-slate-900 flex items-center justify-center">
//         <ArrowRight />
//       </div>
//     </button>
//   );
// };

// export default GetStartedButton;


import React from 'react';
import { useNavigate } from 'react-router-dom';

const ArrowRight = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 12H19M19 12L12 5M19 12L12 19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GetStartedButton = ({
  children = 'GET STARTED',
  onClick,
  type = 'button',
  className = '',
  disabled = false
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate('/auth/signup');
    }
  };

  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={disabled}
      className={`
        bg-gradient-to-r from-cyan-400 via-cyan-500 to-blue-600

        text-slate-900
        rounded-xl
        border-2 border-slate-900
        shadow-lg shadow-cyan-500/30
        transition-all duration-300
        hover:scale-[1.02]
        disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100
        flex items-center overflow-hidden
        ${className}
      `}
    >
      {/* Text Side */}
      <div className="flex-1 px-6 py-3 font-bold text-base uppercase tracking-wide">
        {children}
      </div>

      {/* Arrow Side */}
      <div className="px-4 py-3 bg-gradient-to-r from-blue-500 via-cyan-500 to-cyan-400 border-l-2 border-slate-900 flex items-center justify-center">
        <ArrowRight />
      </div>
    </button>
  );
};

export default GetStartedButton;
